/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Assistant_Edit_Restore_ButtonInputs */



/**
* | output |
* | --- |
* | "Restore and edit" |
*
* @param {Assistant_Edit_Restore_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const assistant_edit_restore_button = /** @type {((inputs?: Assistant_Edit_Restore_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Assistant_Edit_Restore_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Restaurer et modifier")
	if (locale === "de") return /** @type {LocalizedString} */ ("Wiederherstellen und Bearbeiten")
	if (locale === "it") return /** @type {LocalizedString} */ ("Ripristina e modifica")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Восстановить и отредактировать")
	if (locale === "es") return /** @type {LocalizedString} */ ("Restaurar y editar")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("恢复和编辑")
	if (locale === "ja") return /** @type {LocalizedString} */ ("復元と編集")
	if (locale === "hi") return /** @type {LocalizedString} */ ("पुनर्स्थापित करें और संपादित करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Restaurar e editar")
	return /** @type {LocalizedString} */ ("Restore and edit")
});